import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import TagsList from './TagsList';
import { tagsSet, FILTERS } from './constants';

/*
  Presentational component for Tags
*/

const Tags = () => (
  <Filterable
    customClasses="main-content"
    filters={FILTERS}
    data={tagsSet}
    withoutSearch
  >
    <TagsList />
  </Filterable>
);

Tags.displayName = 'TagsPage';

export default Tags;



// WEBPACK FOOTER //
// ./src/containers/elements/Tags/Tags.js